var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('gl-avatar-link',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.bottom",modifiers:{"bottom":true}}],staticClass:"js-user-link",attrs:{"href":_vm.userWebUrl,"data-user-id":_vm.userId,"data-username":_vm.userUsername,"title":_vm.userName}},[_vm._v("\n    @"+_vm._s(_vm.userUsername)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }